import { render, staticRenderFns } from "./InvoiceIndex.vue?vue&type=template&id=9522080e&"
import script from "./InvoiceIndex.vue?vue&type=script&lang=js&"
export * from "./InvoiceIndex.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceIndex.vue?vue&type=style&index=0&id=9522080e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports